import React from "react";

/**
 * A dropdown menu that allows the user to select which columns to display in the table.
 */
export default class ColumnSelector extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            selectedColumns: props.columns.map((column) => {
                if (column.selected === undefined) {
                    return { ...column, selected: true }; // Default to selected if not specified
                }
                return column;
            })
        };

        this.parentCallback = this.props.handleCheckboxChange;
        this.dropDownRef = null;
    }

    setDropdownRef = (element) => {
        this.dropdownRef = element;
    }

    componentDidMount() {
        document.addEventListener("click", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.state.open && 
            this.dropdownRef && 
            !this.dropdownRef.contains(event.target)) {
            this.setState({ open: false });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.columns !== this.props.columns) {
            this.setState({ selectedColumns: this.props.columns });
        }
    }

    toggleDropdown = () => { this.setState({ open: !this.state.open }); }

    selectAll = () => { 
        const newColumns = this.state.selectedColumns.map((column) => {
            column.selected = true;
            return column;
        });
        
        this.parentCallback(newColumns);
    }

    hideAll = () => { 
        const newColumns = this.state.selectedColumns.map((column) => {
            column.selected = false;
            return column;
        });

        this.parentCallback(newColumns);
    }

    handleCheckboxChange = (column) =>  {
        return (event) => {
            if (!column.accessor) {
                console.error("Column accessor is undefined or null:", column);
                return;
            }
            const newColumns = this.state.selectedColumns.map((col) => {
                if (col.accessor === column.accessor) {
                    return { ...col, selected: event.target.checked };
                }
                return col;
            });

            this.parentCallback(newColumns);
        };
    }

    render() {
        const { open, selectedColumns } = this.state;
        
        return (
            <div className="column-selector" ref={this.setDropdownRef}>
                <button onClick={this.toggleDropdown} className="btn btn-primary">Select Columns</button>
                {open && (
                    <div className="col-dropdown-menu">
                        {selectedColumns.map((column) => (
                            <div key={column.accessor} className="dropdown-item">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={column.selected}
                                        onChange={this.handleCheckboxChange(column)}
                                    />
                                    {' ' + column.Header}
                                </label>
                            </div>
                        ))}
                        <div>
                            <button onClick={this.selectAll} className="btn btn-primary">Select All</button>
                            <button onClick={this.hideAll} className="btn btn-primary">Hide All</button> 
                        </div>
                    </div>
                )}
            </div>
        );
    }
}